import { downloadRequest, request } from "@util/request"
import {
  api_v1_band_performers_path,
  performers_api_v1_band_post_path,
} from "../routes"

export type PerformerSortBy = "name" | "last_show" | "tickets_sold"
export type PerformerSortDir = "asc" | "desc"

export async function getPerformersPaged(
  bandId: number,
  page: number,
  perPage = 50,
  search = "",
  sortBy?: PerformerSortBy,
  sortDir?: PerformerSortDir,
) {
  return request({
    queryKey: [
      "performers",
      {
        path: api_v1_band_performers_path(bandId),
        params: {
          page,
          per_page: perPage,
          search: search || undefined,
          sort_by: sortBy,
          sort_dir: sortDir,
        },
      },
    ],
  })
}

export async function getPerformersForPost(bandId: number, postId: number) {
  return request({
    queryKey: [
      "performers_for_post",
      { path: performers_api_v1_band_post_path(bandId, postId) },
    ],
  })
}

export async function downloadPerformersCsv(bandId: number): Promise<void> {
  const blob = await downloadRequest(`/api/v1/bands/${bandId}/performers_csv`)
  const url = URL.createObjectURL(blob)
  const a = document.createElement("a")
  a.href = url
  a.download = `performers-${bandId}.csv`
  a.click()
  URL.revokeObjectURL(url)
}
